module.exports = __webpack_public_path__ + "img/creator1.7367261.png";